/**
 * Shuffles an array in place.
 * @param {T[]} arr Array to shuffle.
 * @returns {T[]} Shuffled array.
 * @link https://stackoverflow.com/a/2450976/10296769
 */
export const shuffle = <T>(arr: T[]) => {
	let currentIndex = arr.length,
		randomIndex;

	// While there remain elements to shuffle.
	while (currentIndex > 0) {
		// Pick a remaining element.
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex--;

		// And swap it with the current element.

		let currElem = arr[currentIndex]!;
		let randomElem = arr[randomIndex]!;

		[currElem, randomElem] = [randomElem, currElem];
	}

	return arr;
};
